(() => {
  const renderCountries = (root) => {
    root.querySelectorAll('[data-brand-country]').forEach((element) => {
      const code = element.dataset.brandCountry;
      if (!/^[A-Z]{2}$/.test(code)) return;
      try {
        const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
        element.querySelector('[data-country-name]').textContent = names.of(code) || code;
        element.querySelector('[data-country-flag]').textContent = String.fromCodePoint(
          ...Array.from(code, (letter) => 127397 + letter.charCodeAt(0))
        );
      } catch (_) {
        // Keep the country code visible when localized region names are unsupported.
      }
    });
  };
  renderCountries(document);
  document.addEventListener('shopify:section:load', (event) => renderCountries(event.target));
})();
